import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import type { Auth0ContextInterface } from '@auth0/auth0-react';
import Navigation from '@/components/Navigation/Navigation';
import { applicationConfig } from '@/config/application';
import { activeConfig } from '@/config';
import Footer from '@/components/Footer/Footer';

interface RouterContext {
  auth: Auth0ContextInterface;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [{ title: activeConfig.branding.appName }],
  }),
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <HeadContent />
      <Navigation />
      <Outlet />
      <Footer />
      {applicationConfig.ENVIRONMENT === 'local' && <TanStackRouterDevtools />}
    </>
  );
}
